import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ isMobile = false }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: 'English', nativeName: 'English', short: 'EN' },
    { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ', short: 'ಕನ್' }
    // Future languages can be easily added here:
    // { code: 'te', name: 'Telugu', nativeName: 'తెలుగు', short: 'తె' },
    // { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', short: 'த' },
    // { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', short: 'हि' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  if (isMobile) {
    // Compact mobile header version with click/tap
    return (
      <div className="relative">
        <button 
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-1 px-2 py-2 text-sm font-medium text-gray-700 hover:text-[#4A5F8F] transition-colors duration-200 rounded-md hover:bg-gray-50"
        >
          <Globe size={18} />
          <span className="text-xs">{currentLanguage.short}</span>
        </button>
        
        {isOpen && (
          <>
            {/* Backdrop to close dropdown */}
            <div 
              className="fixed inset-0 z-40" 
              onClick={() => setIsOpen(false)}
            />
            
            {/* Dropdown menu */}
            <div className="absolute right-0 mt-1 w-32 bg-white rounded-md shadow-lg border border-gray-200 z-50">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => changeLanguage(lang.code)}
                  className={`block w-full text-left px-3 py-2 text-sm transition-colors duration-200 first:rounded-t-md last:rounded-b-md ${
                    i18n.language === lang.code
                      ? 'bg-[#4A5F8F] text-white font-medium'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {lang.nativeName}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    );
  }

  // Desktop view - Compact dropdown
  return (
    <div className="relative group">
      <button className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-gray-700 hover:text-[#4A5F8F] transition-colors duration-200 rounded-md hover:bg-gray-50">
        <Globe size={18} />
        <span>{currentLanguage.nativeName}</span>
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      <div className="absolute right-0 mt-1 w-40 bg-white rounded-md shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`block w-full text-left px-4 py-2 text-sm transition-colors duration-200 first:rounded-t-md last:rounded-b-md ${
              i18n.language === lang.code
                ? 'bg-[#4A5F8F] text-white font-medium'
                : 'text-gray-700 hover:bg-gray-50'
            }`}
          >
            {lang.nativeName}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
